const ClickMultiCheck = (referenceRef, setMultiFilterVisible, event) => {
    if ((!referenceRef.current) || (referenceRef.current.contains(event.target))) {
        return
    }
    setMultiFilterVisible(false)
}

export default ClickMultiCheck;